<template>
  <div id="pers-tab13" name="hres31x-tab13" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">
    <template v-for="(talentType, index) in detail.tableTalentType.rows">
      <detail-template
        :index="index"
        :labels="labels"
        :detail="detail"
        :pcDisp="pcDisp"
        :nowLang="nowLang"
        :mapTyptency="mapTyptency"
        :getDetailTab13Popup="getDetailTab13Popup"
        :detailTab13Popup="detailTab13Popup"
        :tab13PopupColumn="tab13PopupColumn"
        :receivedHres31xdataDetailTab13Popup="receivedHres31xdataDetailTab13Popup"
        inline-template>
        <div>
          <div slot="head" class="sub-topic-box color-skin" @click="toggleDisp()">
            <i class="fa fa-paint-brush icon-sub-topic" aria-hidden="true"></i>
            <div class="sub-topic">{{ talentType.typtency }} - {{ talentType.desc_typtency }}</div>
          </div>

          <div slot="body" class="data-pers-box" v-show="topicDisp">
            <div class="row talent-table-box">
              <div class="col-xs-6 talent-table-heading-left bg-color-skin">
                <div class="col-xs-12 col-sm-3 split-header">{{ labels['HRES31XC15']['30'] }}</div>
                <div class="col-xs-12 col-sm-9 split-header">{{ labels['HRES31XC15']['40'] }}</div>
              </div>
              <div class="col-xs-3 talent-table-heading-center bg-color-skin">{{ labels['HRES31XC15']['60'] }}</div>
              <div class="col-xs-3 talent-table-heading-right bg-color-skin">{{ labels['HRES31XC15']['50'] }}</div>
            </div>

            <template v-for="(talentData, TalentDataindex) in detail.tableTalentData.rows">
              <template v-if="mapTyptency(talentType.typtency, talentData.typtency)">
                <div class="row talent-table-box" :class="{'highlight' : !pcDisp}">
                  <div class="col-xs-6 talent-table-body-left">
                    <div class="col-xs-12 col-sm-3 split-body cursor-pointer">
                      <a data-toggle="modal" data-target="#tab13-popup" ref="popup" @click="getDetailTab13Popup(talentData.codtency)"> {{ talentData.codtency }}</a>
                    </div>
                    <div class="col-xs-12 col-sm-9 split-body">{{ talentData.desc_codtency }}</div>
                  </div>
                  <div class="col-xs-3 talent-table-body-center">{{ talentData.score }}</div>
                  <div class="col-xs-3 talent-table-body-right">{{ talentData.fscore }}</div>
                </div>
              </template>
            </template>
            <tab13-popup :labels="labels"
                         :nowLang="nowLang"
                         :detailTab13Popup="detailTab13Popup"
                         :tab13PopupColumn="tab13PopupColumn" />
          </div>
        </div>
      </detail-template>
    </template>
  </div>
</template>

<script>
import detailTemplate from 'components/hres31x/detailTemplate'

export default {
  name: 'hres31x-tab13',
  components: {
    detailTemplate
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton', 'detailTab13Popup', 'tab13PopupColumn', 'receivedHres31xdataDetailTab13Popup' ],
  methods: {
    mapTyptency (typtencyOfTalentType, typtencyOfTalentData) {
      return typtencyOfTalentType === typtencyOfTalentData
    },
    getDetailTab13Popup (codtency) {
      let searchParams = {
        codtency: codtency
      }
      this.receivedHres31xdataDetailTab13Popup(searchParams)
    }
  }
}
</script>


// WEBPACK FOOTER //
// tab13.vue?9019d31a